import { Type } from 'class-transformer';
import { serializeType } from '@app/shared';

export enum DelegationType {
  Self = 'SELF',
  Approval = 'APPROVAL',
  Submission = 'SUBMISSION',
  Admin = 'EXEC_ASSISTANT'
}

export enum DelegationSubType {
  Admin = 'ADMIN',
  Role = 'ROLE',
  Transaction = 'TXN'
}

export class UserSummary {
  approverName: string;
  cellPhone: string;
  firstName: string;
  fullName: string;
  id: number;
  lastName: string;
  loginId: string;
  obsDepth: number;
  workEmail: string;
}

export class Delegate {
  // @Type(serializeType(Date)) dateFrom: Date;
  // @Type(serializeType(Date)) dateThru: Date;
  dateFrom: string;
  dateThru: string;
  delegationId: number;
  userId: number;
  @Type(serializeType(UserSummary)) userSummary: UserSummary;
  id: number;
  obsId: number;
  orgRoleId: number;
  // parentSubtype: string;
  subtype: string;
  transaction: string;
  txnTypeName: string;
  version: number;
}


export class Delegation {
  @Type(serializeType(Delegate)) delegates: Delegate[];
  id: number;
  policyId: number;
  subtype: string;
  delegationOn: boolean;
  userId: number;
  version: number;

  constructor () {
    this.delegates = [];
  }
}

export class AuthorizedDelegate {
  @Type(serializeType(Delegate)) delegates: Delegate[];
  policyId: number;

  constructor () {
    this.delegates = [];
  }
}
